export var EMVCoVersion;
(function (EMVCoVersion) {
    EMVCoVersion["ZERO_POINT_NINE"] = "0.9";
    EMVCoVersion["ONE_POINT_ZERO"] = "1.0";
    EMVCoVersion["ONE_POINT_ONE"] = "1.1";
    EMVCoVersion["ONE_POINT_TWO"] = "1.2";
    EMVCoVersion["ONE_POINT_THREE"] = "1.3";
    EMVCoVersion["ONE_POINT_FOUR"] = "1.4";
})(EMVCoVersion || (EMVCoVersion = {}));
//# sourceMappingURL=EMVCoVersion.js.map